import React from 'react';
import { landingPageConfig } from '../../../../app_constant/landingPageConfig';

const Breadcrumb = ({ theme }) => {
  const breadcrumbItems = landingPageConfig.appConfig.breadcrumb;

  return (
    <nav className="mb-12 opacity-90" aria-label="breadcrumb">
      <ol className="flex text-sm items-center space-x-3">
        {breadcrumbItems.map((item, index) => (
          <li key={index}>
            {index > 0 && (
              <span 
                className="mx-2 text-lg" 
                style={{ color: theme?.text?.secondary }}
              >
                ›
              </span>
            )}
            {item.url ? (
              <a 
                href={item.url} 
                className="hover:underline transition-all duration-300 hover:scale-105 inline-block"
                style={{ color: theme?.text?.secondary }}
              >
                {item.label}
              </a>
            ) : (
              <span 
                className="font-medium"
                style={{ color: theme?.text?.primary }}
              >
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
